import { useSelector } from 'react-redux'

import classes from './MainSidebar.module.css'
import logo from '../../../images/Logo-sidebar.svg'
import SidebarNav from './FutureSidebarNav' // the old menu is ./SidebarNav
import SidebarNavParents from './SidebarNavParents'
import SupportSidebarNav from './SupportSidebarNav'


const MainSideBar = () => {
    const isLoggedIn = useSelector((state) => state.auth.isLoggedIn)
    const parentLoggedIn = useSelector((state) => state.auth.parentLoggedIn)
    const supportLoggedIn = useSelector((state) => state.auth.supportLoggedIn)


    return (
        <aside className={classes["main-sidebar"]}>
            <div className={classes["main-sidebar__logo"]}><img src={logo} alt='Logo' /></div>
            <ul className={classes["main-sidebar__items"]}>
            {isLoggedIn && <SidebarNav/>}
            {supportLoggedIn && !isLoggedIn && <SupportSidebarNav/>}
            {parentLoggedIn && <SidebarNavParents/>}
            </ul>
        </aside>
    )
}

export default MainSideBar